export const INSTITUTION_CODE_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/**
 * Validates an institution code's format. Caller must lowercase the input first.
 * Returns null when valid, otherwise the user-facing error message.
 */
export function validateCodeFormat(code: string): string | null {
  if (code.length < 2 || code.length > 15) {
    return '2–15 characters';
  }
  if (!INSTITUTION_CODE_REGEX.test(code)) {
    return 'Use lowercase letters, digits and hyphens only';
  }
  return null;
}
